<template>
  <g>
    <path
      d="M12 15.2002C13.7674 15.2002 15.2 13.7675 15.2 12.0002C15.2 10.2329 13.7674 8.80019 12 8.80019C10.2327 8.80019 8.80005 10.2329 8.80005 12.0002C8.80005 13.7675 10.2327 15.2002 12 15.2002Z"
    />
    <path
      d="M20 4.00018H16.83L15.59 2.65018C15.22 2.24018 14.68 2.00018 14.12 2.00018H9.88C9.32 2.00018 8.78 2.24018 8.4 2.65018L7.17 4.00018H4C2.9 4.00018 2 4.90018 2 6.00018V18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V6.00018C22 4.90018 21.1 4.00018 20 4.00018ZM12 17.0002C9.24 17.0002 7 14.7602 7 12.0002C7 9.24018 9.24 7.00018 12 7.00018C14.76 7.00018 17 9.24018 17 12.0002C17 14.7602 14.76 17.0002 12 17.0002Z"
    />
  </g>
</template>
